import React from 'react';
import './ocr.css';

const HeaderLevelData = ({ details = {} }) => {
    const formatValue = (value) => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'object') return JSON.stringify(value);
        return value.toString();
    };

    return (
        <div className="headerleveldata">
            <div className="chip-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {Object.entries(details).map(([key, value]) => {
                    // Skip irnQrCodeData, headerRawData and other complex objects
                    if (key === 'irnQrCodeData' || key === 'headerRawData' || key === "lineItemRawData" || typeof value === 'object') return null;
                    
                    const isAddress = key.toLowerCase().includes('address') && 
                                   typeof value === 'string' && 
                                   value.split(' ').length > 5;
                    
                    return (
                        <div 
                            key={key} 
                            style={{
                                flex: isAddress ? 'calc(40% - 8px)' : 'calc(20% - 8px)',
                                minWidth: isAddress ? '40%' : '20%',
                                background: 'rgb(248 248 246)',
                                padding: '8px 12px',
                                borderRadius: '16px',
                                textAlign: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '60px',
                            }}
                        >
                            <span style={{ fontSize: '12px', color: '#666' }}>{key}</span>
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{formatValue(value)}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default HeaderLevelData;